module.exports = __webpack_public_path__ + "img/back_page.0351c5aa.svg";